import * as React from 'react'

const DEFAULTS = {
  UPLOAD_PRESET: '90seconds',
  DOWNLOAD_URL: '90seconds',
  UPLOAD_URL: '90seconds',
  CLOUDINARY_USER: '90seconds',
}

const CloudinaryContext = React.createContext(DEFAULTS)

export default CloudinaryContext



// WEBPACK FOOTER //
// ./src/components/CloudinaryContext/CloudinaryContext.tsx